const excludeList = ['Alt', 'ArrowDown', 'ArrowLeft', 'ArrowRight', 'ArrowUp', 'Enter', 'Escape', 'Shift', 'Tab', 'Control', 'Meta', 'End', 'Home', 'PageUp', 'PageDown', 'CapsLock', 'ContextMenu', 'Insert', 'Pause', 'PrintScreen', 'F1', 'F2', 'F3', 'F4', 'F5', 'F6', 'F7', 'F8', 'F9', 'F10', 'F11', 'F12', 'NumLock', 'ScrollLock', 'AudioVolumeMute', 'AudioVolumeDown', 'AudioVolumeUp', 'LaunchMediaPlayer', 'LaunchApplication1', 'LaunchApplication2'];

/**
 * This function is reused from a MIT licensed code. Returns the predicted value of an input field when you press a key, but before the new value is rendered.
 *
 * @param {KeyboardEvent} event Keydown event
 * @returns {string} Predicted input value
 */
export default function predictInputValue(event) {
  // Support only keydown and keypress event
  if (event.type !== 'keydown' && event.type !== 'keypress') {
    return null;
  }

  // Skip Cmd+A and other key combinations
  if (event.metaKey || event.ctrlKey) {
    return null;
  }
  if (excludeList.includes(event.key)) {
    return null;
  }
  const {
    target: element
  } = event;

  // We can’t predict values in number inputs
  if (element.type === 'number') {
    return null;
  }
  let {
    selectionStart
  } = element;
  const {
    selectionEnd
  } = element;
  const nextValueArr = element.value.split('');
  let {
    key: replaceWith
  } = event;

  /**
   * If we’re going to add another character, check if we’re not going over the limit set by
   * maxLength. If so, entering the next character will fail, and thus, nextValue will be equal to
   * value.
   */
  if (!replaceWith || element.maxLength < 0 || nextValueArr.length < element.maxLength) {
    nextValueArr.splice(selectionStart, selectionEnd - selectionStart, replaceWith);
  }
  return {
    full: nextValueArr.join(''),
    newInput: replaceWith
  };
}